/**
 * Schema of ResponsavelConfigSms
 * @author Simpli CLI generator
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import ResponsavelConfigSms from '@/model/resource/ResponsavelConfigSms'

export default (model: ResponsavelConfigSms): Schema => ({
  responsavel: {
    content: model.responsavel && model.responsavel.$id,
    input: InputType.SELECT,
  },

  statusSms: {
    content: model.statusSms && model.statusSms.$id,
    input: InputType.SELECT,
    meta: {
      required: true,
    },
  },

  ocorrencia: {
    content: model.ocorrencia && model.ocorrencia.$id,
    input: InputType.SELECT,
  },

  idConfigSmsPk: {
    content: model.idConfigSmsPk,
    editable: false,
  },

  mensagem: {
    content: model.mensagem,
    input: InputType.TEXTAREA,
    meta: {
      required: true,
      maxlength: '2000',
      rows: '2',
    },
  },

  ativo: {
    content: bool(model.ativo),
    hidden: true,
    editable: true,
    input: InputType.CHECKBOX,
  },
})
